import React, { Component } from 'react';
import Cookie from 'js-cookie';
import { MenuItem, DropdownButton } from 'react-bootstrap';

const defaultLocale = 'en';
const languages = [
  { name: 'English', value: 'en' }, // en-gb
  { name: 'Español', value: 'es' },
  { name: 'Català', value: 'ca' }, // ca-es
  { name: 'Français', value: 'fr' },
  { name: 'Italiano', value: 'it' },
  { name: 'Português', value: 'pt' }
];

/**
 * Selector that change locale and put it on the Cookie then reload the page.
 *
 * @author Edgar Guerra <ed.guerra.de@gmail.com>
 * @version 0.1.0
 * @example ./LocaleSelector.md
 */
class LocaleSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      languages: languages,
      selectedLanguage: Cookie.get('locale') || defaultLocale
    };

    this.onSelectLanguage = this.onSelectLanguage.bind(this);
  }

  /**
   * Insert locale into the Cookie then reload the page
   *
   * @param {Object} event
   */
  onSelectLanguage(eventKey) {
    // event.target.value
    this.setState({
      selectedLanguage: eventKey
    });
    Cookie.set('locale', eventKey);
    window.location.reload();
  }

  render() {
    const { selectedLanguage, languages } = this.state;

    const selectedLanguageName = (
      languages.find(l => {
        return l.value === (selectedLanguage || defaultLocale);
      }, []) || { name: 'Languages' }
    ).name;

    return (
      <DropdownButton title={selectedLanguageName} id="basic-nav-dropdown">
        {languages.map(({ name, value }, i) => (
          <MenuItem
            key={`lang-${i}`}
            eventKey={value}
            onSelect={this.onSelectLanguage}
          >
            {name}
          </MenuItem>
        ))}
      </DropdownButton>
    );
  }
}

export default LocaleSelector;
